// src/Slice/BuySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BuyOrders, BuyOrdersResponse } from '../Interface/Order.interface';

const initialState: any = {
  isMemberIdStatus: false,
  buyDatas: [],
  needsRefresh: false,
  loading: false,
  successReview:null,
  successDelete:[],
  successgetReview:[]
};

const BuySlice = createSlice({
  name: 'BuyOrder',
  initialState,
  reducers: {
    startBuyDataFetch(state) {
      state.loading = true;
    },
    fetchBuyData(state, action: PayloadAction<BuyOrders[]>) {
      state.isMemberIdStatus = true;
      state.buyDatas = action.payload;
      state.loading = false;
      state.needsRefresh = false;
    },
    fetchFailBuyData(state) {
      state.isMemberIdStatus = false;
      state.buyDatas = [];
      state.loading = false;
    },
    triggerBuyRefresh(state) {
      state.needsRefresh = true;
    },
    postSuccessReview(state,action){
      state.successReview=action.payload
    },
    deleteSuccessData(state,action){
      state.successDelete= action.payload
    },
    getReviewSuccess(state,action){
      
      state.successgetReview=action.payload
    }
      

  },
});

export const {
  fetchBuyData,
  fetchFailBuyData,
  triggerBuyRefresh,
  startBuyDataFetch,
  postSuccessReview,
  deleteSuccessData,
  getReviewSuccess
} = BuySlice.actions;

export default BuySlice.reducer;
